import { jsPDF } from "jspdf";
import { getBarcodeBySku, getBarcodeByStockId, applyPriceCode, formatNormalPrice } from "../helpers/barcodeHelper";
import { formatWeightValue, getPrintPieceCount } from "./printQuantity";

export const template1 = async (barcode, dataList, config = {}, returnType = "save") => {
  const customLayout = config.custom_template_config_info;
  const hasCustomLayout = Boolean(customLayout);
  const getPosition = (fieldName, fallback) => customLayout?.[fieldName]?.position || fallback;
  const getFontSize = (fieldName, fallback = 6) => {
    const fieldConfig = customLayout?.stone_data?.[fieldName] || customLayout?.[fieldName];
    const groupSize = Number(customLayout?.stone_data?.font_size);
    const configuredSize = Number(fieldConfig?.font_size);
    if (Number.isFinite(configuredSize) && configuredSize > 0) {
      return configuredSize;
    }
    return Number.isFinite(groupSize) && groupSize > 0 && customLayout?.stone_data?.[fieldName]
      ? groupSize
      : fallback;
  };
  const skuPosition = getPosition("sku", { x: 31.5, y: 2.5 });
  const collectionPosition = getPosition("collection", { x: 31.5, y: 3.2 });
  const barcodePosition = getPosition("barcode", { x: 31.5, y: 3.3 });
  const barcodeSize = customLayout?.barcode?.size || { width: 20, height: 4 };
  const stockIdPosition = getPosition("stock_id", { x: 31.5, y: 9.8 });
  const metalPosition = getPosition("metal", { x: 44.5, y: 9.8 });
  const pricePosition = getPosition("price", { x: 31.5, y: 12 });
  const weightPosition = getPosition("weight", { x: 45.5, y: 12 });
  const textPosition = getPosition("text", { x: 45.5, y: 12 });
  const textFontSize = Number(config.text_font_size) || 6;
  const imageConfig = config.image_config;
  const imagePosition = imageConfig?.position || { x: 1, y: 1 };
  const imageSize = imageConfig?.size || { width: 8, height: 8 };

  function numberWithCommas(x) {
    return x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
  }

  const doc = new jsPDF({
    orientation: 'landscape',
    unit: 'mm',
    format: [75, 13]
  });

  const getLockedTextPosition = (fieldName, text, position) => {
    const lock = customLayout?.alignment_locks?.[fieldName];
    if (!lock?.enabled || lock.target !== "barcode" || lock.axis !== "center") {
      return position;
    }

    const offsetX = Number(lock.offset_x) || 0;
    const barcodeCenterX = Number(barcodePosition.x) + (Number(barcodeSize.width) / 2) + offsetX;
    const textWidth = doc.getTextWidth(String(text ?? ""));

    return {
      ...position,
      x: barcodeCenterX - (textWidth / 2),
    };
  };

  // console.log(InventoryList,'InventoryList')
  dataList.map((v, k) => {
    doc.setFont('helvetica', 'bold');

    if (config.image === true && imageConfig?.data?.startsWith("data:image/png;base64,")) {
      try {
        doc.addImage(
          imageConfig.data,
          imageConfig.format || "PNG",
          Number(imagePosition.x) || 1,
          Number(imagePosition.y) || 1,
          Number(imageSize.width) || 8,
          Number(imageSize.height) || 8,
          undefined,
          "FAST"
        );
      } catch (imageError) {
        console.warn("Unable to render barcode profile image", imageError);
      }
    }

    doc.setFontSize(getFontSize("sku", 6));
    const skuTextPosition = getLockedTextPosition("sku", v.SKU, skuPosition);
    doc.text(v.SKU, skuTextPosition.x, skuTextPosition.y, 0);

    const collectionText = config.collection === true
      ? (v.collection_code || v.collection_name)
      : "";
    if (collectionText) {
      doc.setFontSize(getFontSize("collection", 4));
      const collectionTextPosition = getLockedTextPosition("collection", collectionText, collectionPosition);
      doc.text(collectionText, collectionTextPosition.x, collectionTextPosition.y, 0);
    }
    const barcodeY = hasCustomLayout ? barcodePosition.y : (collectionText ? 4.0 : 3.3);

    doc.setFontSize('10');


    if (config.barcode === true) {

      if (config.barcode_display === "stock_id") {
        doc.addImage(getBarcodeByStockId(barcode.data, v.stock_id), 'PNG', barcodePosition.x, barcodeY, barcodeSize.width, barcodeSize.height, null, "SLOW");
      } else if (config.barcode_display === "sku") {
        console.log(barcode.data, 'skuuuu')
        console.log(v.SKU, 'skuuuu')
        doc.addImage(getBarcodeBySku(barcode.data, v.SKU), 'PNG', barcodePosition.x, barcodeY, barcodeSize.width, barcodeSize.height, null, "SLOW");
      } else {
        doc.addImage(getBarcodeByStockId(barcode.data, v.stock_id), 'PNG', barcodePosition.x, barcodeY, barcodeSize.width, barcodeSize.height, null, "SLOW");

      }

    }

    // doc.addFont('ComicSansMS', 'Comic Sans', 'normal','StandardEncoding');

    doc.setFontSize(getFontSize("stock_id", 6));
    doc.setFont('helvetica', 'bold');


    // Remove the currency symbol and commas



    const stockIdTextPosition = getLockedTextPosition("stock_id", v.stock_id, stockIdPosition);
    doc.text(v.stock_id, stockIdTextPosition.x, stockIdTextPosition.y, 0);

    if (config.metal === true) {
      if (v.metal_code) {
        doc.setFontSize(getFontSize("metal", 6));
        const metalTextPosition = getLockedTextPosition("metal", v.metal_code, metalPosition);
        doc.text(v.metal_code, metalTextPosition.x, metalTextPosition.y, 0);

      }
    }


    let numericString;
    if (isNaN(v.price)) {
      numericString = v.price.replace(/[^0-9.]/g, '');
    } else {
      numericString = v.price;
    }

    if (config.price === true) {

      if (v.price) {

        if (config.price_display === "with_currency") {
          doc.setFontSize(getFontSize("price", 6));
          if (isNaN(numericString)) {
            const priceText = formatNormalPrice(numberWithCommas(parseInt(numericString)), config, v.currency);
            const priceTextPosition = getLockedTextPosition("price", priceText, pricePosition);
            doc.text(priceText, priceTextPosition.x, priceTextPosition.y, 0);

          } else {
            console.log('else esle')
            const priceText = formatNormalPrice(numberWithCommas(parseInt(numericString)), config, v.currency);
            const priceTextPosition = getLockedTextPosition("price", priceText, pricePosition);
            doc.text(priceText, priceTextPosition.x, priceTextPosition.y, 0);

          }

        } else {
          doc.setFontSize(getFontSize("price", 6));
          if (isNaN(numericString)) {
            const priceText = applyPriceCode(numberWithCommas(numericString), config, v);
            const priceTextPosition = getLockedTextPosition("price", priceText, pricePosition);
            doc.text(priceText, priceTextPosition.x, priceTextPosition.y, 0);

          } else {
            const priceText = applyPriceCode(numberWithCommas(parseFloat(numericString).toFixed(2)), config, v);
            const priceTextPosition = getLockedTextPosition("price", priceText, pricePosition);
            doc.text(priceText, priceTextPosition.x, priceTextPosition.y, 0);

          }
        }



      }


    }
    const nwt = formatWeightValue(v.NetWt) + "g"
    const gwt = formatWeightValue(v.GrossWt) + "g"
    const showPieceCount = config.pcs !== false;
    const pieceText = `${getPrintPieceCount(v)}p`;

    if (config.weight === true) {
      const weightFontSize = getFontSize("weight", 6);
      doc.setFontSize(weightFontSize);
      if (config.weight_display === "nwt") {
        const weightTextPosition = getLockedTextPosition("weight", nwt, weightPosition);
        const weightTextWidth = doc.getTextWidth(nwt);
        doc.text(nwt, weightTextPosition.x, weightTextPosition.y, 0);
        if (showPieceCount) {
          doc.setFontSize(Math.max(3, weightFontSize - 2));
          doc.text(pieceText, weightTextPosition.x + weightTextWidth + 0.4, weightTextPosition.y - 0.5, 0);
        }
        // doc.text( nwt, 47 ,12, 0);

      } else {
        const weightTextPosition = getLockedTextPosition("weight", gwt, weightPosition);
        const weightTextWidth = doc.getTextWidth(gwt);
        doc.text(gwt, weightTextPosition.x, weightTextPosition.y, 0); //for no currency layout
        if (showPieceCount) {
          doc.setFontSize(Math.max(3, weightFontSize - 2));
          doc.text(pieceText, weightTextPosition.x + weightTextWidth + 0.4, weightTextPosition.y - 0.5, 0);
        }
        // doc.text( gwt, 47 ,12, 0);

      }
    }

    if (config.text === true && config.text_message) {
      const text = String(config.text_message);
      doc.setFontSize(getFontSize("text", textFontSize));
      const textValuePosition = getLockedTextPosition("text", text, textPosition);
      doc.text(text, textValuePosition.x, textValuePosition.y, 0);
    }

    function checkType(value) {
      if (Array.isArray(value)) {
        return "Array";
      } else if (typeof value === "object" && value !== null) {
        return "Object";
      } else {
        return "Neither Object nor Array";
      }
    }
    let stone_list;
    if (checkType(v.Stones_Data) === "Array") {
      stone_list = v.Stones_Data
    } else {
      stone_list = []
      stone_list.push(v.Stones_Data)
    }
    let list_stone = {};
    const configuredStoneCount = Number(config.preview_stone_count);
    const stoneCountLimit = Number.isFinite(configuredStoneCount) && configuredStoneCount > 0
      ? Math.min(5, Math.max(1, Math.floor(configuredStoneCount)))
      : 6;
    const stoneRows = config.preview_only && stone_list.length > 0
      ? Array.from(
        { length: stoneCountLimit },
        (_, index) => ({
          ...stone_list[index % stone_list.length],
          preview_index: index,
        })
      )
      : stone_list.slice(0, stoneCountLimit);

    stoneRows?.map((v, k, arr) => {

      // const key = `${config.stone_name&&v.stone_details._id?v.stone_details._id:"no_sc"}_${config.stone_group&&v.stone_group_details._id?v.stone_group_details._id:"no_sg"}_${config.clarity&&v.stone_clarity_details._id?v.stone_clarity_details._id:"no_clar"}_${config.shape&&v.stone_shape_details._id?v.stone_shape_details._id:"no_sh"}`;
      const stoneKey = `${config?.stone_name && v?.stone_details?._id ? v?.stone_details?._id : ""}_${config?.stone_group && v?.stone_group_details?._id ? v?.stone_group_details?._id : ""}_${config?.clarity && v?.stone_clarity_details?._id ? v?.stone_clarity_details?._id : ""}_${config?.shape && v?.stone_shape_details?._id ? v?.stone_shape_details?._id : ""}_${config?.cut && v?.stone_cut_details?._id ? v?.stone_cut_details?._id : ""}_${config?.color && v?.stone_color_details?._id ? v?.stone_color_details?._id : ""}_${config?.stone_size && v?.stone_size_details?._id ? v?.stone_size_details?._id : ""}`;
      const key = config.preview_only && v.preview_index !== undefined
        ? `${stoneKey}_${v.preview_index}`
        : stoneKey;

      if (!list_stone[key]) {

        list_stone[key] = { ...v };
      } else {
        console.log(list_stone, 'else ees')
        // console.log(merged[key],' merged[key]')
        // console.log(merged[key].Cts,' merged[key].Cts')
        // console.log(stone.Cts,' stone.Cts')
        list_stone[key].Cts = parseFloat(parseFloat(list_stone[key].Cts) + parseFloat(v.Cts)).toFixed(2);
        list_stone[key].Pcs = parseInt(list_stone[key].Pcs) + parseInt(v.Pcs);

      }
      return true;
    })
    const stone_merge_array = Object.values(list_stone).map(stone => ({
      ...stone,
    }));
    console.log(stone_merge_array,"stone_merge_array")
    stone_merge_array.map((v, k) => {
      doc.setFontSize('5');
      const stoneData = customLayout?.stone_data;
      if (hasCustomLayout && stoneData) {
        const lineSpace = stoneData.line_space_offset || 2.5;
        const fields = [
          ["stone_name", config.stone_name, v.stone_details?.code],
          ["stone_group", config.stone_group, v.stone_group_details?.code],
          ["clarity", config.clarity, v.stone_clarity_details?.code],
          ["shape", config.shape, v.stone_shape_details?.code],
          ["color", config.color, v.stone_color_details?.code],
          ["cut", config.cut, v.stone_cut_details?.code],
          ["stone_size", config.stone_size, v.stone_size_details?.code],
          ["stone_pcs", config.stone_pcs, v.Pcs],
          ["stone_weight", config.stone_weight, v.Cts && `${v.Cts}${v.Unit ? v.Unit.substring(0, 1).toLowerCase() : ""}`],
        ];

        fields.forEach(([fieldName, enabled, value]) => {
          const position = stoneData[fieldName]?.position || { x: 55, y: 0 };
          if (enabled && value !== undefined && value !== null && value !== "") {
            doc.setFontSize(getFontSize(fieldName, 5));
            const textPosition = getLockedTextPosition(
              fieldName,
              value,
              { x: position.x, y: position.y + lineSpace * (k + 1) }
            );
            doc.text(String(value), textPosition.x, textPosition.y, 0);
          }
        });
      } else {
        const space = 2.5;
        const y = space * (k + 1);
        const parts = [];
        if (config.stone_name && v.stone_details?.code) parts.push(v.stone_details.code);
        if (config.stone_group && v.stone_group_details?.code) parts.push(v.stone_group_details.code);
        if (config.clarity && v.stone_clarity_details?.code) parts.push(v.stone_clarity_details.code);
        if (config.shape && v.stone_shape_details?.code) parts.push(v.stone_shape_details.code);
        if (config.color && v.stone_color_details?.code) parts.push(v.stone_color_details.code);
        if (config.cut && v.stone_cut_details?.code) parts.push(v.stone_cut_details.code);
        if (config.stone_size && v.stone_size_details?.code) parts.push(v.stone_size_details.code);
        if (config.stone_pcs && v.Pcs) parts.push(v.Pcs.toString());
        if (config.stone_weight && v.Cts) parts.push(v.Cts.toString() + (v.Unit ? v.Unit.substring(0, 1).toLowerCase() : ""));
        if (parts.length) doc.text(parts.join(' '), 55, y);
      }
      return true;
    })

    if (k + 1 < dataList.length) {
      doc.addPage();

    }
    return true;
  })
  switch (returnType) {
    case "save":
      return doc.save("barcode.pdf");

    case "uri":
      return doc.output('datauristring');

    case "printout":
      doc.autoPrint({ variant: 'non-conform' })
      return doc.output('dataurlnewwindow');
    // return doc.addJS('print({});');



    default:
      return doc.save("barcode.pdf");
  }

}
